import { UserRoles } from 'src/utils/enums';

export default function isInternalUi() {
  const { host } = window.location;

  return (
    host === INTERNAL_UI_URL || host.endsWith('.dashboard-ui-int.pages.dev')
  );
}

export function shouldValidateAuth(role: `${UserRoles}` | null): boolean {
  const { host } = window.location;
  // We check for super admin in case the user is trying to sign into the Assist Simulator
  const isSuperAdmin = role === 'ROLE_SUPER_ADMIN';
  return !isSuperAdmin && !isInternalUi() && !host.endsWith('.pages.dev');
}
